import React from 'react';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    ...t.testimonials.items[0],
    avatar: 'https://cdn.magicpatterns.com/uploads/4mWXyWshZLJxLUE174K1rW/Ellipse_28.png'
  }, {
    ...t.testimonials.items[1],
    avatar: 'https://cdn.magicpatterns.com/uploads/mGyEsziYHZ9neJUetPgXco/Mask_group_(7).png'
  }, {
    ...t.testimonials.items[2],
    avatar: 'https://cdn.magicpatterns.com/uploads/87KM94e5rmaTdujVFpac4b/Mask_group_(8).png'
  }];
  return <section id="community-stories" className="py-20 bg-white" data-id="element-292">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
        <div className="text-center mb-16" data-id="element-294">
          <p className="text-primary font-bold tracking-widest text-sm uppercase mb-4" data-id="element-295">
            {t.testimonials.label}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-text-main mb-4" data-id="element-296">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-297">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-secondary/30 p-8 rounded-2xl border border-gray-100 relative flex flex-col h-full" data-id="element-298">
              <Quote className="w-10 h-10 text-primary/20 absolute top-6 left-6" data-id="element-299" />
              <p className="text-text-main italic mb-8 relative z-10 pt-4 text-sm leading-relaxed flex-grow" data-id="element-300">
                "{item.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-301">
                <img src={item.avatar} alt={item.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-302" />
                <div data-id="element-303">
                  <h4 className="font-bold text-text-main text-sm" data-id="element-304">
                    {item.name}
                  </h4>
                  <p className="text-xs text-text-muted" data-id="element-305">{item.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}